import React from 'react';
import cn from 'clsx';
import { createElementKey } from 'utils';
import { Section, Typography } from 'common/components';
import { CheckCircleIcon } from '@fronton/icons-react';
import { FENCES_ADVANTAGES_MAP } from './fences-advantages-section-constants';
import {
  fencesAdvantagesSectionIcon,
  fencesAdvantagesSectionItemText,
  fencesAdvantagesSectionList,
  fencesAdvantagesSectionListStylesMap,
} from './fences-advantages-section-styles';

type FencesAdvantagesSectionProps = {
  fencesType: string;
};

export const FencesAdvantagesSection: React.FC<FencesAdvantagesSectionProps> = ({ fencesType }) => {
  const advantagesList = FENCES_ADVANTAGES_MAP[fencesType];

  return (
    <Section>
      <ul
        className={cn(
          fencesAdvantagesSectionList,
          fencesAdvantagesSectionListStylesMap[advantagesList.length]
        )}>
        {advantagesList.map((text, index) => (
          <li key={createElementKey('advantages', index)}>
            <CheckCircleIcon className={fencesAdvantagesSectionIcon} size="xxl" strokeWidth={0.5} />
            <Typography className={fencesAdvantagesSectionItemText} size="body_long" variant="m">
              {text}
            </Typography>
          </li>
        ))}
      </ul>
    </Section>
  );
};
